import { render, staticRenderFns } from "./LayoutVertical.vue?vue&type=template&id=54cde9c5&"
import script from "./LayoutVertical.vue?vue&type=script&lang=js&"
export * from "./LayoutVertical.vue?vue&type=script&lang=js&"
import style0 from "./LayoutVertical.vue?vue&type=style&index=0&id=54cde9c5&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54cde9c5')) {
      api.createRecord('54cde9c5', component.options)
    } else {
      api.reload('54cde9c5', component.options)
    }
    module.hot.accept("./LayoutVertical.vue?vue&type=template&id=54cde9c5&", function () {
      api.rerender('54cde9c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/layout-vertical/LayoutVertical.vue"
export default component.exports